'use client';
import useTouchMove from '@/hooks/useTouchMove';
import { getDoubleDimensional } from '@/utils';
import { SectionBody } from '@ssv-website/web-ui';
import Image from 'next/image';
import React from 'react';
import CasePaging from '../../_components/Paging';

const RelatedRead = ({ data }: { data: CaseTypes.CaseItem[] }) => {
  const { active, ref, onNext, onPrev } = useTouchMove();
  const renderList = getDoubleDimensional(data, 2);
  const pageTotal = Math.ceil(data.length / 2);
  const onLink = (caseAliasID: string) => {
    window.location.href = '/case/' + caseAliasID;
  };
  return (
    <>
      <div className="my-16 mobile:hidden">
        <SectionBody title="相关阅读" subTitle="让向善宣发，更加得心应手">
          <div ref={ref} className="flex overflow-x-auto mb-6 gap-3">
            {renderList.map((item, index) => (
              <div
                className="gap-3 flex-shrink-0 grid grid-cols-2 w-full"
                key={index}
              >
                {item.map((v, i) => (
                  <Card
                    key={i}
                    title={v.title}
                    tags={v.label}
                    cover={v.image}
                    code={v.caseAliasID}
                    text={v.description}
                    caseNo={v.caseNo}
                  />
                ))}
              </div>
            ))}
          </div>
          <CasePaging
            total={pageTotal}
            page={active + 1}
            next={onNext}
            prev={onPrev}
          />
        </SectionBody>
      </div>
      {/* mobile */}
      <div className="hidden bg-white mobile:block mt-1 py-4 pb-12 text-[#353F49]">
        <div className="text-base font-600 leading-6">相关阅读</div>
        <div className="flex flex-col">
          {data.map((item, index) => (
            <div
              className="mt-4"
              key={index}
              onClick={() => onLink(item.caseAliasID)}
            >
              <Image
                src={item.image}
                // src={list[0].cover}
                alt=""
                className="w-full rounded-md"
                width={300}
                height={200}
              />
              <div className="text-sm font-600 mt-2">{item.title}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default RelatedRead;
interface ICard {
  title: string;
  text: string;
  cover: string;
  tags: string[];
  code: string;
  caseNo: string;
}
const Card = (props: ICard) => {
  const { title, text, cover, tags, code, caseNo } = props;
  const onLink = () => {
    window.location.href = '/case/' + code;
  };

  return (
    <div
      className="bg-white box-border p-7 cursor-pointer rounded-lg w-full"
      onClick={onLink}
    >
      <div className="text-2xs mb-2 font-700 text-[#323C46] line-clamp-1 text-ellipsis">
        {title}
      </div>

      <div className="flex justify-between gap-x-6">
        <div className="flex-1">
          <div className="text-sm font-400 text-[#464F58]/60 line-clamp-3 text-ellipsis h-fit">
            {text}
          </div>
          <div className="flex flex-wrap gap-x-4 mt-2 line-clamp-2 overflow-hidden text-ellipsis">
            {tags.map((v, i) => (
              <span key={i} className="text-sm text-[#5A636B]/60 font-400">
                {v}
              </span>
            ))}
          </div>
        </div>
        <div className="w-[150px]">
          <Image
            src={cover}
            alt=""
            className="w-[150px] h-[88px] rounded-md"
            width={300}
            height={200}
          />
          <div className="text-xs font-400 line-clamp-1 text-ellipsis overflow-hidden text-[#848A90]/60 mt-2">
            编号：{caseNo}
          </div>
        </div>
      </div>
    </div>
  );
};
